import React, {useState} from "react";
import { useListContext } from "react-admin";
import { Button, Toolbar } from "@material-ui/core";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import {Box} from "@material-ui/core";
import {Typography} from "@material-ui/core";

const Empty = () => {
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                No results found
            </Typography>
        </Box>)
};

const Paginator = () => {
    const { page, perPage, total, data, setPage } = useListContext();
    const nbPages = Math.ceil(total / perPage) || 1;
    return (
        (total === 0) ? <Empty/> :
        nbPages > 1 &&
            <Toolbar>
            	{page > 1 &&
                    <Button type="button" color="primary" key="prev" onClick={() => setPage(page - 1)}>
                    	<ChevronLeft />
                        Prev
                    </Button>
            	}
            	{page !== nbPages &&
                    <Button type="button" color="primary" key="next" onClick={() => setPage(page + 1)}>
                        Next
                    	<ChevronRight />
                    </Button>
            	}
            </Toolbar>
    );
};

export default Paginator;
